import {PriorityIcon} from '@priority-software/priority-style-react';

export enum TabIds {
    typeColumn = 'typeTabTitle',
    data = 'data',
    axes = 'axes'
}

export enum SingleSeriesChartTypesOptions {
    column2d = 'column2d',
    bar2d = 'bar2d',
    line = 'line',
    pie2d = 'pie2d',
    doughnut2d = 'doughnut2d',
    bubble = 'bubble',
    angulargauge = 'angulargauge',
    pyramid = 'pyramid',
    funnel = 'funnel',
    kpi = 'kpi'
}

export enum MultiSeriesChartTypesOptions {
    mscolumn2d = 'mscolumn2d',
    msbar2d = 'msbar2d',
    msline = 'msline',
    stackedcolumn2d = 'stackedcolumn2d',
    stackedbar2d = 'stackedbar2d'
}

export const ChartIcons = {
    [SingleSeriesChartTypesOptions.column2d]: PriorityIcon.columnBar,
    [SingleSeriesChartTypesOptions.bar2d]: PriorityIcon.oneBar,
    [SingleSeriesChartTypesOptions.doughnut2d]: PriorityIcon.doughnut,
    [SingleSeriesChartTypesOptions.pie2d]: PriorityIcon.pieBar,
    [SingleSeriesChartTypesOptions.line]: PriorityIcon.variantBar,
    [SingleSeriesChartTypesOptions.pyramid]: PriorityIcon.linePyramid2,
    [SingleSeriesChartTypesOptions.angulargauge]: PriorityIcon.gauges,
    [SingleSeriesChartTypesOptions.bubble]: PriorityIcon.bubbleBar,
    [SingleSeriesChartTypesOptions.funnel]: PriorityIcon.linePyramid,
    [SingleSeriesChartTypesOptions.kpi]: PriorityIcon.kpi,
    [MultiSeriesChartTypesOptions.mscolumn2d]: PriorityIcon.msColumn,
    [MultiSeriesChartTypesOptions.msbar2d]: PriorityIcon.msBar,
    [MultiSeriesChartTypesOptions.msline]: PriorityIcon.variantBar2,
    [MultiSeriesChartTypesOptions.stackedcolumn2d]: PriorityIcon.stackedColumn,
    [MultiSeriesChartTypesOptions.stackedbar2d]: PriorityIcon.stackedBar
};

export interface ChartData {
    label?: string;
    value?: number | string;
}

export interface BubbleChartData {
    x: string;
    y: string;
    z: string;
    name: string;
}

export interface GaugeChartData {
    minValue: string;
    maxValue: string;
    code: string;
}

export interface GaugeDial {
    value: string;
}

export interface BubbleXaxisData {
    label: string;
    x: string;
}

export interface CategoryItem {
    label: string;
}

export interface DatasetItem {
    seriesname: string;
    data: {value: string}[];
}

export const scaleMarks = [
    {mark: 'Red', colId: 4, hexColor: '#e44a00'},
    {mark: 'Yellow', colId: 5, hexColor: '#f8bd19'},
    {mark: 'Green', colId: 6, hexColor: '#6baa01'},
    {mark: 'White', colId: 7, hexColor: '#ffffff'}
];

export const gaugeSettings = {
    showGaugeBorder: 1,
    gaugeBorderColor: '#16213D',
    showValue: 1,
    valueBelowPivot: 1,
    pivotRadius: 20
};

export const procEname = 'RUNGENREP';
export const procType = 'P';

export const coralColor = '#FFDFD9';
export const customPalette = [
    '#3B37E6',
    '#A142FF',
    '#5ED0F9',
    '#60C57C',
    '#F5A458',
    '#FF80E3',
    '#ED7B6F',
    coralColor,
    '#D7F7FF',
    '#47D2DD'
];

export const defaultThousandSign = ',';
export const defaultDecimalSign = '.';

export enum ChartDimensions {
    xAxis = 'xAxis',
    yAxis = 'yAxis',
    zAxis = 'zAxis',
    category = 'category',
    series = 'series'
}

export const topXMaxValue = 99;
